module.exports = __webpack_public_path__ + "static/media/galeryCeilings3.af034edc.jpg";